import { GetProjectResponse } from "api/generatedApi";
import { Role, useRoleRestriction } from "./use-role-restriction";

export const useProjectRestrictions = (project?: GetProjectResponse) => {
  const { hasRole } = useRoleRestriction(project ?? {});

  const canCreateProject = (): boolean => {
    return true;
  };

  const canEditDescription = (): boolean => {
    if (hasRole([Role.Owner, Role.Manager, Role.AssistantOwner])) {
      return true;
    }
    return false;
  };

  const canEditProjectTypeAndInfo = (): boolean => {
    if (hasRole([Role.Owner, Role.Manager, Role.AssistantOwner])) {
      return true;
    }
    return false;
  };

  const canDeleteDocument = (): boolean => {
    if (hasRole([Role.Owner, Role.Manager, Role.AssistantOwner])) {
      return true;
    }
    return false;
  };

  const canDownloadDocument = (): boolean => {
    return true;
  };

  const canUploadDocument = (): boolean => {
    if (hasRole([Role.Owner, Role.Manager, Role.AssistantOwner])) {
      return true;
    }
    return false;
  };

  const canDeleteProject = (): boolean => {
    if (hasRole([Role.Owner])) {
      return true;
    }
    return false;
  };

  return { canCreateProject, canDeleteProject, canEditDescription, canEditProjectTypeAndInfo, canDeleteDocument, canDownloadDocument, canUploadDocument };
};
